import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase/config";

// Mock data as fallback if Firebase is not configured or empty
const MOCK_ADS = [
    { id: 'mock-1', title: 'Toyota Aqua 2018', price: 'LKR 6,500,000', location: 'Colombo', image: 'https://placehold.co/600x400/1e293b/ffffff?text=Toyota+Aqua' },
    { id: 'mock-2', title: 'Honda Vezel 2016', price: 'LKR 7,200,000', location: 'Gampaha', image: 'https://placehold.co/600x400/1e293b/ffffff?text=Honda+Vezel' },
    { id: 'mock-3', title: 'Suzuki Alto 2020', price: 'LKR 3,800,000', location: 'Kandy', image: 'https://placehold.co/600x400/1e293b/ffffff?text=Suzuki+Alto' },
    { id: 'mock-4', title: 'Nissan Leaf 2019', price: 'LKR 5,500,000', location: 'Kurunegala', image: 'https://placehold.co/600x400/1e293b/ffffff?text=Nissan+Leaf' },
];

export const fetchAds = async () => {
    try {
        const querySnapshot = await getDocs(collection(db, "ads"));
        if (querySnapshot.empty) {
            console.log("No ads found in Firestore, returning MOCK data.");
            return MOCK_ADS;
        }

        const totalAdsCount = querySnapshot.size;

        // AUTO-ACTIVE if more than 50 ads
        if (totalAdsCount >= 50) {
            const pendingAds = querySnapshot.docs.filter(doc => doc.data().status === 'pending');
            if (pendingAds.length > 0) {
                // Background update pending ads to approved
                const { doc, updateDoc } = await import("firebase/firestore");
                pendingAds.forEach(adDoc => {
                    updateDoc(doc(db, "ads", adDoc.id), { status: 'approved' })
                        .catch(err => console.warn("Failed to auto-approve ad:", adDoc.id, err));
                });
            }
        }

        const adsList = querySnapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
        })).filter(ad => totalAdsCount >= 50 || ad.status !== 'pending');

        return adsList;
    } catch (error) {
        console.error("Error fetching ads from Firestore (likely config issue):", error);
        return MOCK_ADS; // Fallback so UI doesn't break
    }
};

export const fetchLeasingOffers = async () => {
    // Similar structure for leasing offers
    try {
        const querySnapshot = await getDocs(collection(db, "leasing"));
        if (querySnapshot.empty) {
            return [];
        }
        return querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    } catch (error) {
        console.warn("Could not fetch leasing offers:", error);
        return [];
    }
};
